<template>
  <div class="card m-0">
    <div class="card-content">
      <div class="card-body">
        <ValidationObserver v-slot="{ handleSubmit }">
          <form class="form form-horizontal"
                @submit.prevent="handleSubmit(submitForm)">
            <div class="form-body">
              <div class="row">
                <div class="col-12" v-if="errorMessage.trim() !== ''">
                  <div class="form-group row">
                    <div class="col-12">
                      <div class="alert alert-danger">
                        {{ errorMessage.trim() }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group row">
                    <div class="col-md-3">
                      <label for="categoryName">Nomlanishi</label>
                    </div>
                    <div class="col-md-9">
                      <ValidationProvider name="Nomlanishi" rules="required" v-slot="{ errors }">
                        <div class="position-relative has-icon-left">
                          <input type="text" id="categoryName" class="form-control" v-model="category.name"
                                 name="fname-icon" placeholder="Nomlanishi">
                        </div>
                        <span class="text-danger" v-if="errors.length > 0">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group row">
                    <div class="col-md-3">
                      <label for="normName">Nishon</label>
                    </div>
                    <div class="col-md-5">
                      <ValidationProvider name="Nishon" rules="required" v-slot="{ errors }">
                        <div class="position-relative has-icon-left">
                          <input type="number" id="normName" class="form-control"
                                 v-model="category.displayOrder" placeholder="Nishon">
                        </div>
                        <span class="text-danger" v-if="errors.length > 0">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group row">
                    <div class="col-md-3">
                      <label>Kurs rasmi</label>
                    </div>
                    <div class="col-md-9">
                      <div class="position-relative has-icon-left">
                        <div class="vs-checkbox-con vs-checkbox-primary">
                          <div id="upload-picture-large">
                            <upload-image
                                :data-images="images"
                                :multiple="false"
                                :popup-text="'Rasm'"
                                :primaryText="'Rasm category'"
                                :dragText="'Rasmni yuklash'"
                                :browseText="''"
                                @upload-success="uploadPictureSuccess"
                                @before-remove="beforeRemovePicture"
                                @edit-image="editPicture"
                                idUpload="filePicture"
                                editUpload="productUpdateEditId"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group row">
                    <div class="col-md-3">
                      <label for="commentcategory">Komment kategory</label>
                    </div>
                    <div class="col-md-9">
                      <div class="position-relative has-icon-left">
                                            <textarea type="text" id="commentcategory" class="form-control"
                                                      v-model="category.comment"
                                                      name="fname-icon" placeholder="Komment kategory"
                                                      cols="5" rows="5">
                                            </textarea>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group row">
                    <div class="col d-flex justify-content-end">
                      <button type="submit" class="btn btn-info waves-effect waves-light mr-1"
                              :disabled="loading"
                              v-if="successMessage === ''">
                                                <span class="spinner-border spinner-border-sm" role="status"
                                                      aria-hidden="true"
                                                      v-if="loading"/>
                        {{ update ? 'Yangilash' : 'Saqlash' }}
                      </button>
                      <button type="button" class="btn btn-success mr-1" disabled="disabled"
                              v-if="successMessage !== ''">
                        <i class="feather icon-check"/>
                        {{ successMessage }}
                      </button>
                      <button type="button" class="btn btn-outline-info waves-effect waves-light"
                              v-if="successMessage === ''"
                              :disabled="loading"
                              @click="closeModal">Bekor qilish
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
import {ValidationProvider, extend, ValidationObserver} from 'vee-validate';
import {required} from 'vee-validate/dist/rules';

extend('required', {
  ...required,
  message: 'Kiriting {_field_}'
});

export default {
  name: "categoryForm",
  props: {
    category: Object,
    getCategory: Function
  },
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      images: [],
      errorMessage: '',
      loading: false,
      successMessage: ''
    }
  },
  methods: {
    submitForm() {
      this.loading = true;
      this.update ? this.updateCategory() : this.storeCategory();
    },
    storeCategory() {
      this.$api.post(`admin/Reference/InsertCategory`, this.categoryFormData())
          .then(res => {
            if (!res.error) {
              this.succMessage('Сохранено');
              this.getCategory()
            } else {
              this.errMessage(res.error);
            }
          })
          .catch(err => {
            this.errMessage('Ошибка');
          })
          .finally(() => {
            this.loading = false;
          });
    },
    updateCategory() {
      this.$api.put('admin/Reference/CategoryUpdate', this.categoryFormData())
          .then(res => {
            if (!res.error) {
              this.succMessage('Обновлено');
            } else {
              this.errMessage(res.error);
            }
          })
          .catch(err => {
            this.errMessage('Ошибка');
          })
          .finally(() => {
            this.loading = false;
          });
    },
    categoryFormData() {
      let form = new FormData();
      for (let prop in this.category) {
        if (prop === 'imageFormData')
          continue;
        form.append(prop, this.category[prop]);
      }

      return form;
    },
    errMessage(errorMessage) {
      this.errorMessage = errorMessage;
      setTimeout(() => {
        this.errorMessage = '';
      }, 5000);
    },
    succMessage(successMessage) {
      this.successMessage = successMessage;
      setTimeout(() => {
        this.closeModal();
        this.$emit('saved');
      }, 1000);
    },
    // UPLOAD PICTURE STARTED
    uploadPictureSuccess(formData, index, fileList) {
      this.category.picture = formData.get('file');
    },
    beforeRemovePicture(index, done, fileList) {
      if (this.category.picture) {
        this.deleteStoredImage(this.category.picture);
        this.category.picture = null;
      }
      done();
    },
    editPicture(formData, index, fileList) {
      this.images = [];
      this.category.picture = null;
    },
    async deleteStoredImage(imageName) {
      let params = {};
      params.photo = imageName;
      return this.$api.post('file-uploads/delete-image', params).then(res => {
        if (res) {
          return res;
        } else {
          return false;
        }
      }).catch(error => {
        return false;
      }).finally(item => {
        ///
      });
    },
    // UPLOAD PICTURE FINISHED
  },
  computed: {
    update() {
      return this.category.id !== 0;
    }
  },
  watch: {},
  created() {
    if (this.update && this.category.picture)
      this.images.push(
          {
            path: `${this.baseURL}${this.category.picture}`,
            default: 1,
            highlight: 1,
            caption: 'caption to display. receive', // Optional
          }
      );
  }
}
</script>

<style scoped>

</style>